import { useEffect, useState } from "react";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import CommonConfirmationModal from "../../Components/Modals/CommonConfirmationModal";
import { Column } from "../../Components/Tables/Table";
import { ApiResponse } from "../../model/common/apiResponse";
import { header } from "../../Shared/Cards/Card.type";
import { prepareSearchColumns } from "../../Utility/Utility";
import SetupList from "../setup/list/List";
import { changeStatus } from "../setup/service/setup.service";
import { ItemsOverviewProps } from "./model/Items.type";
import { deleteItem } from "./service/items.service";
import useUserStore, { userAccess } from "../../store/auth/userStore";

export default function CustomerOverview() {
  const pageName = "Items";
  const addUrl = "/account/client/items/add";
  const listUrl = "/account/client/items";
  const gridUrl = "";
  const statusUpdateEndpoint = "items";
  const ListingEndpoint = "items/query";
  const [showRowClicked, setShowRowClicked] = useState(false);
  const [userAccess, setUserAccess] = useState<userAccess | null>(null);
  const { currentUser, fetchUser } = useUserStore();
  const [loading, setLoading] = useState(true);
  const handleRowClick = (data: any) => {
    if (showRowClicked == false) {
      navigation(`/account/client/items/details/${data.id}`);
    }
  };

  const navigation = useNavigate();
  const { viewtype } = useParams<{ viewtype: string }>();
  const [statusData, setStatusData] = useState<any>();
  const [data, setData] = useState<any>(null);
  const [confirmModalData, setConfirmModalData] = useState({
    item_id: 0,
    showconfModal: false,
    message: "",
  });
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const handleconfShow = () => {
    setConfirmModalData((prevData) => ({
      ...prevData,
      showconfModal: true,
    }));
  };
  const handleconfClose = () => {
    setConfirmModalData({
      item_id: 0,
      showconfModal: false,
      message: ``,
    });
  };
  const handelEditAction = (data: any) => {
    navigation(`/account/client/items/edit/${data.id}`);
  };

  const onModalSubmit = (isAccept: boolean) => {
    if (confirmModalData.item_id !== 0 && isAccept) {
      deleteItem(confirmModalData.item_id).then(
        (response: ApiResponse<any>) => {
          if (response.status == 200) {
            toast.success("Item deleted successfully");
            setRefreshTrigger((prev) => prev + 1);
          } else {
            toast.error("Failed to delete item");
          }
        }
      );
    }
    handleconfClose();
  };
  const handelDeleteAction = (data: ItemsOverviewProps) => {
    setConfirmModalData({
      item_id: data.id,
      showconfModal: true,
      message: `Are you sure you want to delete item '${data.name}'?`,
    });
  };
  const handelInactiveAction = (data: any, isActive: boolean) => {
    const payload = {
      is_active: isActive,
    };
    changeStatus(`${statusUpdateEndpoint}/${data.id}`, payload).then(
      (response: ApiResponse<any>) => {
        if (response.status == 200) {
          setStatusData(response.data);
          toast.success("Item status updated successfully!", {
            duration: 5000,
          });
        } else {
          toast.error("Failed to update Item status!", {
            duration: 5000,
          });
        }
      }
    );
  };

   useEffect(() => {
        setLoading(true);
        fetchUser().then((user: userAccess | null) => {
          setUserAccess(user);
        }).then(() => {
          setLoading(false);
        })
    }, [fetchUser])

  const columns: Column[] = [
    {
      name: "Item Code",
      selector: (row: ItemsOverviewProps) => (
        <span
          className="cursor-pointer text-primary"
          onClick={() => handleRowClick(row)}
        >
          {row.code ? row.code : '-'}
        </span>
      ),
    },
    {
      name: "Item Name",
      selector: (row: ItemsOverviewProps) => row.name ? row.name : '-',
    },
    {
      name: "Item Type",
      selector: (row: ItemsOverviewProps) => "-",
    },
    {
      name: "No. of Components",
      selector: (row: ItemsOverviewProps) => "0",
    },
    {
      name: "UOM",
      selector: (row: ItemsOverviewProps) => row.uom_code ? row.uom_code : '-',
    },
    {
      name: "Status",
      selector: (row: ItemsOverviewProps) => {
        return row.is_active === 1 ? (
          <span className="badge text-bg-light border border-2 px-3 border-info-subtle ">
            Active
          </span>
        ) : (
          <span className="badge text-bg-light border border-2 px-3 border-danger-subtle ">
            Inactive
          </span>
        );
      },
    },
    {
      name: <></>,
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelEditAction(row)}
            >
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelInactiveAction(row, !row.is_active)}
            >
              {row.is_active ? "Inactive" : "Active"}
            </li>
            {
                userAccess && userAccess?.is_spherewms_admin ? (
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelDeleteAction(row)}
            >
              Delete
            </li>
            ) : (
              <></>
            )
            }
          </ul>
        </>
      ),
    },
  ];

  const headers: header[] = [
    {
      name: "Code",
      selector: (row: ItemsOverviewProps) => row.code,
    },
  ];
  const db_columns = [
    {
      data: "item.id",
    },
    {
      data: "item.code",
    },
    {
      data: "item.description",
    },
    {
      data: "item.name",
    },
    {
      data: "default_purchase_uom.code as uom_code",
    },
    {
      data: "item.is_active",
    },
  ];
  const exclude_columns: any = ["is_active"];
  const search_columns = exclude_columns
    ? prepareSearchColumns(db_columns, exclude_columns)
    : [];
  const sorting_order = [
    {
      column: "item.id",
      dir: "desc",
    },
  ];
  const getDetails = (item: any) => {
    navigation(`/account/client/item/details/${item.id}`);
  };

  const handleDataChange = (data: any) => {
    setData(data);
  };

  return (
    <>
      <SetupList
        pageName={pageName}
        columns={columns}
        addUrl={addUrl}
        listUrl={listUrl}
        gridUrl={gridUrl}
        viewtype={viewtype || "list-view"}
        headers={headers}
        getDetails={getDetails}
        search_columns={search_columns}
        db_columns={db_columns}
        update_status_url={statusUpdateEndpoint}
        statusData={statusData}
        setStatusData={setStatusData}
        onDataChange={handleDataChange}
        data={data}
        refreshTrigger={refreshTrigger}
        handelEditAction={handelEditAction}
        listEndpoint={ListingEndpoint}
        sorting_order={sorting_order}
      />
      <CommonConfirmationModal
        customClassName="header-border"
        show={confirmModalData.showconfModal}
        confirmBtnText="YES"
        cancelBtnText="NO"
        content={<> {confirmModalData.message} </>}
        onModalSubmit={onModalSubmit}
      />
    </>
  );
}
